export default "__VITE_ASSET__CwCy$_2R__"